import React from 'react';
import { Link } from 'react-router-dom';
import Spacing from '../Spacing';
import { Icon } from '@iconify/react';

export default function CommentsWidget({ title, comments }) {
  return (
    <div id="comments" className="comments-area">
      <h2 className="comments-title cs-semi_bold cs_fs_24 cs_semibold mb-0">
        {title}
      </h2>
      <Spacing md="45" />
      <ol className="comment-list">
        {comments && comments.map((comment, index) => (
          <li className="comment" key={index}>
            <div className="comment-body">
              <div className="comment-author vcard">
                <img
                  className="avatar"
                  src="/images/blog/avatar_1.png"
                  alt="Author"
                />
                <Link to="/" className="url">
                  {comment.author || 'Visitor'}
                </Link>
              </div>
              <div className="comment-meta">
                <Icon icon="fa6-solid:clock" />
                <Link to="/">{comment.date || 'Just now'}</Link>
              </div>
              <p>
                {comment.text}
              </p>
              <div className="reply">
                <Link className="comment-reply-link" to="/">
                  Reply
                </Link>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
